import React from 'react';
import { observer } from 'mobx-react';
import SVGIconView from 'lib/images/svg-icon-view';
import { FormattedMessage } from 'react-intl';

import twitter from 'four-nets/icons/svg/icon_social-twitter.svg';

import { Twitter } from 'lib/social/twitter';
import Styled from 'styled';

import SocialButtonView from '../social-button-view';

import defaultStyles from './twitter-button-view.scss';

@Styled(defaultStyles)
@observer
class TwitterButtonView extends React.Component {
    onClick = (event: Event) => {
        if (this.props.onClick) {
            this.props.onClick(event);
        }

        window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');

        event.preventDefault();
    };

    render() {
        const { liked, shareOptions, ...rest } = this.props;
        this.href = Twitter.shareURL(shareOptions);

        return (
            <SocialButtonView
                href={this.href}
                onClick={this.onClick}
                {...rest}
                icon={<SVGIconView src={twitter} />}
                label={
                    <React.Fragment>
                        <FormattedMessage id='SHARE_VENDOR' /> na Twitter
                    </React.Fragment>
                }
            />
        );
    }
}

export default TwitterButtonView;
